export function getUnitVolumeColumnIndexes<T>(
  checkIsUnitVolumeColumn: (column: T) => boolean,
  columns: T[]
) {
  return columns.reduce<number[]>(
    (acc, column, index) => checkIsUnitVolumeColumn(column) ? [...acc, index] : acc
  , []);
}
